import $ from 'jquery';

export const ACTIVE_CLASS = "js-heart-active";
export const FAV_BUTTON_SELECTOR = ".js-heart-button";
export const MODAL_SELECTOR = "#heart-feature-sync";

const PRODUCT_CODE_TOKEN = "{productCode}";
const FAVORITE_AJAX_URL = "/favorite-products/favorite/" + PRODUCT_CODE_TOKEN;
const UNFAVORITE_AJAX_URL = "/favorite-products/unfavorite/" + PRODUCT_CODE_TOKEN;

const OUTLINE_SELECTOR = ".icon--heart-emoji-outline";
const FILL_SELECTOR = ".icon--heart-emoji-fill";
const ANIMATION_CLASS = "heartbeat";

const NOTIFICATION_SELECTOR = ".js-favorite-notify";
const SCREEN_READER_SELECTOR = ".u-screen-reader";
const FAVORITES_COUNT_SELECTOR = "#my_favorites_count";

const FAVORITE_NOTIFICATION = "favorite-notification";
const UNFAVORITE_NOTIFICATION = "unfavorite-notification";
const FAVORITE_MESSAGE = "favorite-message";
const UNFAVORITE_MESSAGE = "unfavorite-message";

function onFavoritesPage() {
    return window.location.pathname && window.location.pathname.startsWith("/my-favorites");
}

function resetFavoritedButton($heartOutline, $heartFill) {
    $heartOutline.removeClass('u-hide');
    $heartFill.addClass('u-hide').removeClass(ANIMATION_CLASS);
}

function favoriteProduct($button, productCode) {
    let $heartOutline = $button.find(OUTLINE_SELECTOR);
    let $heartFill = $button.find(FILL_SELECTOR);

    $.post(FAVORITE_AJAX_URL.replace(PRODUCT_CODE_TOKEN, productCode), function(result) {
        if (result.success) {
            $button.addClass(ACTIVE_CLASS);

            var $favCount = $(FAVORITES_COUNT_SELECTOR);
            $favCount.text(Number($favCount.text()) + 1);
            $favCount.prev().find('.u-screen-reader').text(`Favorites ${$favCount.text()} items.`);

            sendFillToScreenReader($button);
            snapChatAddToWishList(productCode);
        } else {
            resetFavoritedButton($heartOutline, $heartFill);
            $button.next(NOTIFICATION_SELECTOR).text("Error occurred trying to " + $button.data(FAVORITE_MESSAGE));
        }
    });
}

function unfavoriteProduct($button, productCode) {
    let $heartOutline = $button.find(OUTLINE_SELECTOR);
    let $heartFill = $button.find(FILL_SELECTOR);

    if (onFavoritesPage()) {
        $button.closest("li").fadeOut();
    }

    $.post(UNFAVORITE_AJAX_URL.replace(PRODUCT_CODE_TOKEN, productCode), function(result) {
        if (result.success) {
            $button.removeClass(ACTIVE_CLASS);

            let $favCount = $(FAVORITES_COUNT_SELECTOR);
            let count = Number($favCount.text());
            if (count > 0) {
                $favCount.text(--count);
                $favCount.prev().find('.u-screen-reader').text(`Favorites ${count} items.`);
            }

            if (onFavoritesPage()) {
                if (count === 0) {
                    window.location.reload();
                } else {
                    window.refreshPLP();
                }
            }

            sendUnfillToScreenReader($button);
        } else {
            $heartOutline.addClass('u-hide');
            $heartFill.removeClass('u-hide').addClass(ANIMATION_CLASS);
            $button.next(NOTIFICATION_SELECTOR).text("Error occurred trying to " + $button.data(UNFAVORITE_MESSAGE));
        }
    });
}

export function initFavorites() {
    if (!onFavoritesPage() || window.rcProps.favoritesCount > 0) {
        $("body").on("click", FAV_BUTTON_SELECTOR, function (e) {
            let $this = $(this);
            let productCode = $this.data("code");

            if (window.rcProps.isGuest && !window.rcProps.canGuestsHaveFavorites) {
                $(MODAL_SELECTOR).data("codes", productCode);
                openModal();
            } else if ($this.hasClass(ACTIVE_CLASS)) {
                unfavoriteProduct($this, productCode);
            } else {
                favoriteProduct($this, productCode);
            }

            e.preventDefault();
        });
    }

    $(MODAL_SELECTOR + " button").on("click", function () {
        let queryChar = /\?/.test(window.rcProps.signInHref) ? "&" : "?";
        window.location.href = window.rcProps.signInHref + queryChar + "favCodes=" + encodeURIComponent($(MODAL_SELECTOR).data("codes"));
    });
}

export function sendFillToScreenReader($button) {
    $button.next(NOTIFICATION_SELECTOR).text($button.data(FAVORITE_NOTIFICATION));
    $button.find(SCREEN_READER_SELECTOR).text($button.data(UNFAVORITE_MESSAGE));
}

export function sendUnfillToScreenReader($button) {
    $button.next(NOTIFICATION_SELECTOR).text($button.data(UNFAVORITE_NOTIFICATION));
    $button.find(SCREEN_READER_SELECTOR).text($button.data(FAVORITE_MESSAGE));
}

export function openModal() {
    $.modal({
        open: "heart-feature-sync",
        triggerOpen: true,
        onClose: function() {
            if (window.rcProps.favoritesCount === 0) {
                resetFavoritedButton($(OUTLINE_SELECTOR), $(FILL_SELECTOR));
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/favorite-products.js